<template>
<div class="grid fixed h100" style="grid-template-columns: auto 1fr auto; grid-template-rows: auto auto;" v-loading="loading">
<!-- <div class="blocco h100 w100" v-if="loading"><circle4></circle4></div> -->

<!-- <div class="headerbar">
  
    <p>
     <el-date-picker
      v-model="today"
      type="date"
      placeholder="Pick a day"
      v-on:change="changeDate()"
      :picker-options="datePickerOptions"
      v-if="!nogrid">
    </el-date-picker>

    <el-date-picker
      v-model="rangepicker"
      type="daterange"
      range-separator="To"
      start-placeholder="Start date"
      end-placeholder="End date"
      v-on:change="changeRange()"
      :picker-options="datePickerOptions"
      v-if="!nogrid">
    </el-date-picker>

  </p>

</div> -->

<navbar :hotel="hotel" :settings="settings" :ombrelli="ombrelli" :getOmbrelli="getOmbrelli"></navbar>

    <!-- <div class="h100 w20"></div> -->
  <div style="display: grid; justify-items: center; align-content: start; align-content: start; overflow: auto; height: 100vh; padding: 0px;">  

  <!-- {{hotel}} -->
  <!-- <div id="embedded-slack" /> -->

  <!-- <p v-for="(ombrello, index) in ombrelli">{{index}} {{ombrello}}</p> -->

  <!-- <p>{{disabledDates}}</p> -->

<!--   <div class="step" v-if="nogrid" style="margin-top: 24px; width: 900px;">
    <el-steps :active="grid.active" align-center finish-status="success">
      <el-step title="Numero Ombrellone" @click.native="e => stepHandler(e, 0)"></el-step>
      <el-step title="Seleziona modello" description="" @click.native="e => stepHandler(e, 1)"></el-step>
      <el-step title="Controlla e salva" description="" @click.native="e => stepHandler(e, 2)"></el-step>
    </el-steps>
  </div> -->

<!-- <div class="w100" style="background-image: url('/static/img/waves.png'); background-position: bottom; background-size: cover;"> -->
<div class="grid range">
<div class="selector">
  <p>
     <el-date-picker
      v-model="today"
      type="date"
      placeholder="Pick a day"
      v-on:change="changeDate()"
      :picker-options="datePickerOptions"
      format="dd-MM-yyyy"
      v-if="!nogrid">
    </el-date-picker>

    <el-date-picker
      v-model="rangepicker"
      type="daterange"
      range-separator="al"
      start-placeholder="Data inizio"
      end-placeholder="Data fine"
      v-on:change="changeRange()"
      :picker-options="datePickerOptions"
      format="dd-MM-yyyy"
      v-if="!nogrid">
    </el-date-picker>

    <!-- <button type="button" class="btn btn-blue" v-on:click="getqr">get qr</button> -->

    <!-- <img v-bind:src="qrimg" /> -->

    <!-- {{qrimg}} -->

  </p>

  </div>

</div>

  
    <div class="grid thegrid" :style='style' style="">
    <!-- <h1>{{hotel.hotelname}} - {{hotelid}}</h1> -->
      <!-- <div class="grid" :style='style' v-cloak> -->

      <!-- {{loading}} -->

      <div v-if="rangeview" class="grid ombrello" v-for="(ombrello, index) in ombrelli">
        
        <div class="grid seat range" :style="" >

          <div class="grid data">
            <div class="grid nr">{{ombrello.ombrid}}</div>
            <!-- <p v-for="date in ombrello.dates">{{date.date}} {{date.free}}</p> -->
          </div>

          <div class="grid days" style="grid-template-columns: repeat(7, 1fr);">
            <div class="grid" v-for="(day, indexd) in ombrello.dates" >
              <!-- <span class="grid day" :class="{ arriving : day.fulldate === ombrello.arrival }" v-if="!day.free" v-on:click="bookedshow(ombrello, day)"> -->
              <span class="grid day" v-if="!day.free" v-on:click="bookedshow(ombrello, day)">
              <!-- {{day.guests[0].departure}} -->
              <el-popover
                placement="top-start"
                :title="'Dettagli ombrello ' + ombrello.ombrid"
                width="auto"
                trigger="hover"
                fit="true">
                <el-table :data="day.guests" style="width: 100%;">
                  <el-table-column width="auto" property="room" label="Stanza"></el-table-column>
                  <el-table-column :min-width="100" property="name" label="Nome"></el-table-column>
                  <el-table-column width="120" property="arrival" label="Arrivo"></el-table-column>
                  <el-table-column width="120" property="departure" label="Partenza"></el-table-column>
                  <el-table-column width="auto" property="note" label="Note"></el-table-column>
                </el-table>
                <el-button slot="reference">{{day.date}}</i></el-button>
              </el-popover>

              </span>

              <!-- <span class="grid day free" v-on:click="newshow(ombrello, day)" v-if="day.free" :class="{ departing : day.fulldate === ombrello.departure }">{{day.date}}</span> -->
              <span class="grid day free" v-on:click="newshow(ombrello, day)" v-if="day.free" >{{day.date}}</span>
            </div>
          </div>

        </div>

      </div>

        <!-- <drag class="grid ombrello drag" v-for="(ombrello, index) in ombrelli" v-if="!rangeview"
        :key="ombrello._id"
        :transfer-data="{ ombrello }"
        @dragstart="dragging = !ombrello.free"
        @dragend="dragging = null"> -->

        <div class="grid ombrello drag" :class="{ nonvisible : !ombrello.visible }" v-for="(ombrello, index) in ombrelli" v-if="!rangeview">

        <div class="grid seat" v-if="!ombrello.free" :class="{ minimal : !hotel.poolsettings.chairs }" v-on:click="show(ombrello)">
          <div class="grid header" :class="{ hidden : !hotel.poolsettings.chairs }">
<!--           
            <img src="../assets/img/beach-deckchair-.png" v-if="hotel.poolsettings.beds">
            <img src="../assets/img/beach-chair.png" v-if="hotel.poolsettings.chairs">

            <span class="grid" v-if="hotel.poolsettings.chairs"><a v-on:click="removechair(index, ombrello.chairs, ombrello._id, hotelid)"><span class="fa fa-minus-square"></span></a>{{ombrello.chairs}}<a v-on:click="addchair(index, ombrello.chairs, ombrello._id, hotelid)"><span class="fa fa-plus-square"></span></a></span>

            <span class="grid" v-if="hotel.poolsettings.beds"><a v-on:click="removebed(index, ombrello.beds, ombrello._id, hotelid)"><span class="fa fa-minus-square"></span></a>{{ombrello.beds}}<a v-on:click="addbed(index, ombrello.beds, ombrello._id, hotelid)"><span class="fa fa-plus-square"></span></a></span> -->
            
            <div class="grid items">

            <!-- {{ombrello.guestsinday}} -->
            
            <div class="grid item" v-for="item in ombrello.guestsinday[0].items">
              <div class="grid details" v-if="item.num > 0">
                <!-- <span class="badge">{{item.num}}</span> -->
                <span v-html="item.icon" v-for="nu in item.num" class="icon"></span>
              </div>  
            </div>

            </div>

          </div>

          <el-popover
            placement="top-start"
            :title="'Dettagli ombrello ' + ombrello.ombrid"
            width="auto"
            trigger="hover"
            v-if="!hotel.poolsettings.guest && !hotel.poolsettings.room"
            fit="true"
            :content="ombrello.guestsinday[0].name">
            <el-table :data="ombrello.guestsinday" style="width: 100%;">
              <el-table-column width="auto" property="room" label="Stanza"></el-table-column>
              <el-table-column :min-width="100" property="name" label="Nome"></el-table-column>
              <el-table-column width="120" property="arrival" label="Arrivo"></el-table-column>
              <el-table-column width="120" property="departure" label="Partenza"></el-table-column>
            </el-table>
            <el-button slot="reference"><i class="fas fa-info-circle"></i></el-button>
          </el-popover>

          <div class="grid ident" v-if="hotel.poolsettings.room || hotel.poolsettings.guest">
          <!-- {{ombrello.guestsinday}} -->
            <span class="room" v-if="hotel.poolsettings.room">{{ombrello.guestsinday[0].room}}</span>
            <span v-if="ombrello.guest && hotel.poolsettings.guest" v-on:click="show(ombrello)">{{ombrello.guestsinday[0].name}}</span>
            <span v-if="!ombrello.guest && hotel.poolsettings.guest" v-on:click="show(ombrello)">no guest name</span>
            <span class="room" v-if="ombrello.guestsinday.length > 1">{{ombrello.guestsinday[1].room}}</span>
            <span v-if="ombrello.guest && ombrello.guestsinday.length > 1" v-on:click="show(ombrello)">{{ombrello.guestsinday[1].name}}</span>
          </div>
          <div class="grid data" :class="{ minimal : !hotel.poolsettings.chairs || !hotel.poolsettings.beds, hidden : !hotel.poolsettings.arrival }">
            <div class="grid nr">{{ombrello.ombrid}}</div>
            <div class="grid date" v-if="hotel.poolsettings.arrival || hotel.poolsettings.departure" :class="{ hidden : !hotel.poolsettings.arrival }">
              <span><span class="fa fa-chevron-right"></span> {{ombrello.arrival}}</span>
              <span><span class="fa fa-chevron-left"></span> {{ombrello.departure}}</span>
            </div>
          </div>
        </div>

        <!-- <div class="blocco seat" v-if="!ombrello.free">
        <div class="header blocco row">
          <div class="blocco">
            <img src="../assets/img/beach-deckchair-.png">
            <span><a v-on:click="removechair(index, ombrello.chairs, ombrello._id, hotelid)"><span class="fa fa-minus-square"></span></a>{{ombrello.chairs}}<a v-on:click="addchair(index, ombrello.chairs, ombrello._id, hotelid)"><span class="fa fa-plus-square"></span></a></span>
          </div>
          <div class="blocco">
            <img src="../assets/img/beach-chair.png">
            <span><a v-on:click="removebed(index, ombrello.beds, ombrello._id, hotelid)"><span class="fa fa-minus-square"></span></a>{{ombrello.beds}}<a v-on:click="addbed(index, ombrello.beds, ombrello._id, hotelid)"><span class="fa fa-plus-square"></span></a></span>
          </div>
        </div>
        <div class="ident blocco row">
          <span class="room">{{ombrello.room}}</span>
          <span v-if="ombrello.guest" v-on:click="show(ombrello)">{{ombrello.guest}}</span>
          <span v-if="!ombrello.guest" v-on:click="show(ombrello)">no guest</span>
        </div>
        <div class="caldata blocco row">
          <div class="blocco nr">{{ombrello.ombrid}}</div>
          <div class="blocco">
            <span><span class="fa fa-chevron-right"></span> {{ombrello.arrival}}</span>
            <span><span class="fa fa-chevron-left"></span> {{ombrello.departure}}</span>
          </div>
        </div>
        </div> -->

<!--           <drop class="blocco seat free drop" :id="ombrello._id" v-if="ombrello.free"
          :key="ombrello._id"
          :class="{ allowed: dragging === ombrello.free, lock: lock === ombrello._id }"
          @dragenter="lock = ombrello._id"
          @dragleave="handleDragover(ombrello, ombrello._id)"
          @drop="handleDrop">
            <a class="blocco nr" v-on:click="show(ombrello)" :id="ombrello._id">{{ombrello.ombrid}}</a>
          </drop> -->

          <div class="blocco seat free" :id="ombrello._id" v-if="ombrello.free" v-on:click="show(ombrello)">
            <a class="blocco nr" :id="ombrello._id">{{ombrello.ombrid}}</a>
          </div>

        <!-- </drag> -->
        </div>

<!--         <div v-if="ombrelli.length < hotelgrid">
            <div class="blocco ombrello">
              <div class="blocco seat free">
                <div class="blocco nr">
                  <form >
                      <p><input type="text" class="form-control" name="ombrid" v-model="addombrello.ombrid" placeholder="id ombrello"></p>
                      <a v-on:click="addombrell" class="btn btn-violet">add seat</a>
                  </form>
                </div>
              </div>
            </div>
          </div> -->

      <!-- </div> -->

    </div>

    </div>

    <!-- {{overview}} -->

    <div class="grid overview" >

    <!-- <div class="sub-title">list suggestions on input</div> -->
     
<!--      <el-autocomplete
      class="inline-input"
      v-model="state1"
      :fetch-suggestions="querySearch"
      placeholder="Please Input"
      @select="handleSelect"
    ></el-autocomplete> -->

      <!-- {{filteredList}} -->
      <el-input placeholder="Nome ospite o numero camera" v-model="query" ></el-input>

      <h3 v-if="overview.arrivals.length > 0">Check In</h3>

      <div v-if="overview.arrivals.length > 0" class="grid arrivals">
        <span class="arrival" v-for="arrival in filteredArrivals">{{arrival.ombrello.ombrid}} - {{arrival.guest.name}}@{{arrival.guest.room}}</span>  
      </div>

      <h3 v-if="overview.departures.length > 0">Check Out</h3>

      <div v-if="overview.departures.length > 0" class="grid departures">
        <span class="departure" v-for="(departure, index) in filteredDepartures" @click="open('overviewdetail', departure, index)" style="cursor: pointer;">{{departure.ombrello.ombrid}} - {{departure.guest.name}}@{{departure.guest.room}} <!-- <span v-if="departure.ombrello.cashable"><i class="fas fa-euro-sign"></i></span> --></span>
      </div>

      <div class="spacer sm"></div>

      <div class="grid stays">
        <span class="stay" v-for="stay in filteredStays">{{stay.ombrello.ombrid}} - {{stay.guest.name}}@{{stay.guest.room}}</span>
      </div>

    </div>

 
    <modal name="overviewdetail" :width="360" :minWidth="360" :maxWidth="1040" height="auto" :adaptive="true" scrollable>

      <div class="grid overviewdetail" v-if="!loading && checkoutbasket">
        <h1>Checkout {{checkoutbasket.ombrid}}</h1>
        <hr>
        <small>Ospite</small>
        <span><strong>{{checkoutbasket.guests[0].name}}</strong></span>
        <div class="spacer xs"></div>
        <small>Camera</small>
        <span><strong>{{checkoutbasket.guests[0].room}}</strong></span>
        <div class="spacer xs"></div>
        <small>Arrivo</small>
        <span><strong>{{checkoutbasket.guests[0].arrival}}</strong></span>
        <div class="spacer xs"></div>
        <small>Partenza</small>
        <span><strong>{{checkoutbasket.guests[0].departure}}</strong></span>
        <div class="spacer xs"></div>
        <span>{{checkoutbasket.guests[0].note}}</span>
        <div class="spacer xs"></div>
        <!-- <small>{{checkoutbasket.cashable}}</small> -->
        <!-- <hr> -->
        <!-- <small v-for="season  in checkoutbasket.seasons">{{season}}</small> -->
        <div class="grid items">
          <div class="grid item" v-for="item in checkoutbasket.guests[0].items">
            <span v-html="item.icon"></span>
            <!-- <span>{{item.name}}</span> -->
            <span>{{item.num}}</span>
          </div>
        </div>
        <!-- <div>{{disabledDates}}</div> -->
        <!-- <small>{{ombrellos}}</small> -->
        <!-- <p>{{cashier}}</p> -->
        <div class="grid total" v-if="hotel.cashier && checkoutbasket.cashable && hotel.seasons.length !== 0">
          <span><small>Base</small>:</span>
          <span class="text-right"><small>€ {{cashierbasket.tocash}}</small></span>
          <span><small>Extra</small>:</span>
          <span class="text-right"><small>€ {{cashierbasket.extra}}</small></span>
          <span><strong>Totale:</strong></span>
          <span class="text-right"><strong>€ {{cashierbasket.total}}</strong></span>
        </div>
        <div class="spacer sm"></div>
        <button type="button" class="btn btn-green" v-if="hotel.cashier && hotel.seasons.length !== 0"><i class="fas fa-check-circle"></i> Checkout Ospite</button>
      </div>

    </modal>
    

    <!-- <settings :hotel="hotel"></settings> -->

    <Hello :ombrellos="ombrellos" :hotel="hotel" :disabledDates="disabledDates" :range="range" v-on:changeOmbrellodate="onChange"></Hello>


  
</div>
</template>

<script>
  import Vue from 'vue'
  import {Circle4} from 'vue-loading-spinner'
  import datepicker from 'vue-date'
  import {DateRange} from 'vue-date-range'
  import Moment from 'moment'
  import { extendMoment } from 'moment-range'
  import 'moment/locale/de'
  import 'moment/locale/it'
  const moment = extendMoment(Moment)
  import Navbar from '@/components/Navbar'
  import Hello from '@/components/Hello-World'
  // import Settings from '@/components/Settings'
  import { Drag, Drop } from 'vue-drag-drop'
  var host = process.env.ROOT_API
  export default {
    name: 'ombrelli',
    props: ['auth', 'authenticated'],
    data () {
      return {
        checkboxGroup1: ['Shanghai'],
        checkboxGroup2: ['Shanghai'],
        checkboxGroup3: ['Shanghai'],
        checkboxGroup4: ['Shanghai'],
        alphabet: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
        letters: {
          first: 'A',
          last: '',
          act: 0,
          row: 1
        },
        numbers: {
          first: 1,
          last: 0,
          act: 0
        },
        query: '',
        filtered: '',
        loading: true,
        nogrid: false,
        qrimg: '',
        grid: {
          direction: '',
          letter: true,
          number: true,
          firststep: false,
          active: 0
        },
        state1: '',
        langs: [{
          lang: 'it'
        }, {
          lang: 'de'
        }],
        hotel: '',
        secret: '',
        checkoutbasket: '',
        // pregrid: '',
        ombrelli: [],
        style: '',
        rangestyle: '',
        hotelid: '',
        ombrellos: '',
        addombrello: {
          ombrid: ''
        },
        overview: {
          arrivals: [],
          departures: [],
          stays: []
        },
        date: ['2016-10-16', '2024-10-05'],
        today: moment().format('YYYY-MM-DD'),
        lang: 'it',
        range: {
          startDate: moment(),
          endDate: ''
          // startDate: '2019-04-03',
          // endDate: '2019-04-10'
        },
        rangepicker: [],
        rangeviewdata: '',
        // disabledRange: {
        //   startDate: moment(),
        //   endDate: moment().add(9, 'days')
        // },
        disabledDates: [],
        disabledDatesBasket: [],
        datePickerOptions: {
          firstDayOfWeek: 1,
          onPick: this.changeRange
        },
        firstDayOfWeek: 1,
        editombrid: false,
        dragging: null,
        lock: null,
        location: 'beach',
        rangeview: false
      }
    },
    components: {
      datepicker,
      Circle4,
      DateRange,
      'Navbar': Navbar,
      Hello,
      Drag,
      Drop
      // EmbeddedSlack
      // chat
    },
    sockets: {
      connect: function () {
        // console.log('socket connected')
      },
      stream: function (val) {
        // console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
        // console.log(val.hotelid)
        if (val.hotelid === this.hotelid) {
          // console.log('an umbrella was updated')
          this.getOmbrelli()
        }
      },
      disconnect: function () {
        // console.log('socket error')
        // this.$notify({
        //   group: 'foo',
        //   title: 'Error loading Data',
        //   text: 'I´ll fix it in a few',
        //   type: 'warning',
        //   duration: 5000
        // })
      }
    },
    methods: {
      getqr () {
        this.$http
          .get(host + '/api/get/pass',
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            // console.log(data)
            this.qrimg = data.body
            // this.$modal.hide('settings')
            // this.getOmbrelli()
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 500
            })
          })
      },
      stepHandler (e, i) {
        console.log(e, i)
        this.grid.active = i
      },
      nextStep () {
        this.grid.active++
      },
      previousStep () {
        if (this.grid.active === 2) {
          this.ombrelli = []
          this.grid.direction = ''
          this.grid.active = 0
        } else {
          this.grid.active--
        }
      },
      filter (query) {
        console.log(this.query, this.overview.arrivals.filter(item => item.ombrid === this.query))
        this.filtered = this.overview.arrivals.filter(item => item.guest.name === this.query)
      },
      // querySearch (queryString, cb) {
      //   var links = this.linkst
      //   var results = queryString ? links.filter(this.createFilter(queryString)) : links
      //   // call callback function to return suggestions
      //   console.log(results)
      //   cb(results)
      // },
      // createFilter (queryString) {
      //   return (link) => {
      //     // console.log(link, queryString)
      //     return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      //   }
      // },
      handleSelect (item) {
        // console.log(item)
      },
      disabledFunc: function (dayMoment) {
        // console.log(dayMoment, moment(dayMoment).isBetween(moment('2019-04-03'), moment('2019-04-12')))
        // if (moment(dayMoment).isBetween(moment('2019-04-14'), moment('2019-04-24'))) {
        if (this.disabledDates.includes(moment(dayMoment).format('YYYY-MM-DD'))) {
          // console.log(moment(dayMoment).format('YYYY-MM-DD'))
          return true
        } else {
          // console.log(moment(dayMoment).format('YYYY-MM-DD'))
          return false
        }
      },
      preCheckDate () {
        // console.log('preCheckDate', this.ombrellos.guests)
        // console.log(!this.hotel.singledaybooking)
        this.disabledDates = []
        this.ombrellos.guests.forEach((guest, indexo) => {
          if (guest.name !== this.ombrellos.guest) {
            var start = moment(guest.arrival, 'YYYY-MM-DD')
            var end = moment(guest.departure, 'YYYY-MM-DD')
            var range = moment.range(start, end)
            var dates = Array.from(range.by('days', { excludeStart: false, excludeEnd: !this.hotel.singledaybooking })).map(m => m.format('YYYY-MM-DD'))
            Array.prototype.push.apply(this.disabledDates, dates)
            // console.log('guest: ', guest.name, dates)
          }
        })
      },
      preCheckDateBasket () {
        // console.log('preCheckDate', this.ombrellos.guests)
        console.log(!this.hotel.singledaybooking)
        this.disabledDatesBasket = []
        this.checkoutbasket.guests.forEach((guest, indexo) => {
          if (guest.name !== this.ombrellos.guest) {
            var start = moment(guest.arrival, 'YYYY-MM-DD')
            var end = moment(guest.departure, 'YYYY-MM-DD')
            var range = moment.range(start, end)
            var dates = Array.from(range.by('days', { excludeStart: false, excludeEnd: !this.hotel.singledaybooking })).map(m => m.format('YYYY-MM-DD'))
            Array.prototype.push.apply(this.disabledDatesBasket, dates)
            // console.log('guest: ', guest.name, dates)
          }
        })
      },
      // checkDate (date) {
        // console.log(moment(date).format('YYYY-MM-DD'))
        // date = moment(date).format('YYYY-MM-DD')
        // return moment(date).isBetween(moment(this.ombrellos.arrival), moment(this.ombrellos.departure))
        // console.log(date, moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12')))
        // if (moment(date).isBetween(moment('2019-04-12'), moment('2019-04-14'))) {
        //   return true
        // } else {
        //   return false
        // }
        // this.ombrellos.guests.forEach(function (guest, indexo) {
        //   console.log(date, moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12')))
        //   if (moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12'))) {
        //     return true
        //   } else {
        //     return false
        //   }
        // })
      // },
      handleDragover (group, data, event) {
        // console.log(data)
        // console.log(group.ombrid)
        // console.log(event)
        if (!group.free) {
          event.dataTransfer.dropEffect = 'none'
        }
      },
      handleDrop (group, data, key) {
        // console.log(group.ombrello.ombrid, data.target.id)
        this.moveombrello(group.ombrello, data.target.id)
        // alert(`You dropped with data: ${JSON.stringify(data)}`)
      },
      changeombrid () {
        // console.log('changeombrid')
        this.editombrid = true
      },
      onChange (range) {
        // console.log('range: ', range.minDate, range.maxDate)
        this.range = range
        // console.log('ombrello onChange: ', moment(range))
      },
      // setRange (p) {
      //   if (typeof p === 'number') {
      //     // console.log(p)
      //     this.range = {
      //       startDate: moment().add(p, 'days'),
      //       endDate: moment()
      //     }
      //   }
      // },
      show (ombrello) {
        console.log('show ombrello: ', ombrello)
        console.log(this.today)
        this.ombrellos = ombrello
        this.range = {}
        if (ombrello.free) {
          this.ombrellos.items = this.hotel.items
          // this.ombrellos.chairs = this.hotel.chairs
          // this.ombrellos.beds = this.hotel.beds
        } else if (!ombrello.items) {
          this.ombrellos.items = this.hotel.items
        }
        // this.hotel.items.forEach((item, indexo) => {
        // })
        // if (ombrello.beds === null) { this.ombrellos.beds = this.hotel.beds }
        // this.date[0] = ombrello.arrival
        // this.date[1] = ombrello.departure
        // console.log('arrival ', moment(ombrello.arrival, 'DD.MM.YYYY'))
        if (!ombrello.free) {
          // console.log('show ombrello arrival: ', moment(ombrello.arrival).format('DD.MM.YYYY'))
          this.range.startDate = moment(ombrello.arrival)
          this.range.endDate = moment(ombrello.departure)
        } else if (this.hotel.singledaybooking) {
          this.range.startDate = moment(this.today)
          this.range.endDate = moment(this.today)
        } else {
          this.range.startDate = moment(this.today)
          this.range.endDate = moment(this.today).add(1, 'days')
        }
        // if (ombrello.free) {
        //   this.range.endDate = moment(ombrello.departure)
        // } else {
        //   this.range.endDate = moment(this.today)
        // }
        this.preCheckDate()
        this.$modal.show('hello-world')
      },
      newshow (ombrello, day) {
        console.log('newshow ombrello: ', ombrello, day)
        console.log(this.today)
        this.ombrellos = {}
        this.ombrellos.items = this.hotel.items
        this.ombrellos.guests = ombrello.guests
        this.ombrellos.ombrid = ombrello.ombrid
        this.ombrellos.hotelid = ombrello.hotelid
        this.ombrellos.free = true
        this.ombrellos._id = ombrello._id
        this.ombrellos.passid = ''
        this.range = {}
        this.preCheckDate()
        this.$modal.show('hello-world')
      },
      bookedshow (ombrello, day) {
        console.log('bookedshow ombrello: ', ombrello, day)
        console.log(this.today)
        this.ombrellos = {}
        this.range = {}
        this.range.startDate = moment(day.guests[0].arrival)
        this.range.endDate = moment(day.guests[0].departure)
        this.ombrellos.items = day.guests[0].items
        this.ombrellos.guests = ombrello.guests
        Vue.set(this.ombrellos, 'guest', day.guests[0].name)
        Vue.set(this.ombrellos, 'room', day.guests[0].room)
        this.ombrellos.ombrid = ombrello.ombrid
        this.ombrellos.hotelid = ombrello.hotelid
        this.ombrellos.guestnr = day.guestnr
        this.ombrellos.free = false
        this.ombrellos._id = ombrello._id
        this.ombrellos.passid = day.guests[0].passid
        this.preCheckDate()
        this.$modal.show('hello-world')
      },
      // checkOut (data, index) {
      //   // this.$modal.show(modal)
      //   this.ombrellos = data.ombrello
      //   // const filteredItems = this.ombrellos.guests.filter((item, key) => key === index)
      //   // console.log('key: ', filteredItems)
      //   this.ombrellos.guests.push(data.guest)
      //   // this.ombrellos.seasons = data.ombrello.seasons
      //   console.log(data, index, this.ombrellos)
      //   this.ombrellos.guests = this.ombrellos.guests.filter((item, key) => key === index)
      //   this.preCheckDate()
      // },
      open (modal, data, index) {
        this.checkoutbasket = data.ombrello
        console.log('guest: ', data)
        // const filteredItems = this.ombrellos.guests.filter((item, key) => key === index)
        // console.log('key: ', filteredItems)
        this.checkoutbasket.guests = []
        this.checkoutbasket.guests.push(data.guest)
        // this.ombrellos.seasons = data.ombrello.seasons
        // console.log(data, index, this.ombrellos)
        // console.log(data, index, this.overview.departures[index])
        // this.checkoutbasket.guests = this.checkoutbasket.guests.filter((item, key) => key === index)
        this.preCheckDateBasket()
        this.$modal.show(modal)
      },
      hide () {
        this.$modal.hide('hello-world')
      },
      settings () {
        this.$modal.show('settings')
      },
      updatehotel: function () {
        this.$http
          .post(host + '/api/updatehotel', { hotel: this.hotel },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            // console.log(data)
            this.$modal.hide('settings')
            // this.getOmbrelli()
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 500
            })
          })
      },
      // moveombrello: function (old, newo) {
      //   console.log(old, newo)
      //   // this.ombrellos = old
      //   // this.closeombrello()
      //   // old._id = newo
      //   // old.ombrid = ombrid
      //   // console.log(this.ombrellos)
      //   // this.ombrellos = newo
      //   this.$http
      //     .post(host + '/api/moveombrello', { old: old, newo: newo },
      //     {
      //       headers: {
      //         'Authorization': 'Bearer ' + localStorage.jwt
      //       }
      //     },
      //     ).then((data) => {
      //       // console.log(data)
      //       this.dragging = null
      //       this.getOmbrelli()
      //     }, (error) => {
      //       console.log(error)
      //       this.$notify({
      //         group: 'foo',
      //         title: 'Error loading Data',
      //         text: 'I´ll fix it in a few',
      //         type: 'warning',
      //         duration: 500
      //       })
      //     })
      // },
      closeombrello (index) {
        // console.log(this.ombrellos.guests, index)
        this.ombrellos.guests.splice(index, 1)
        // console.log('updated: ', this.ombrellos.guests)
        this.ombrellos.guest = ''
        this.ombrellos.room = ''
        this.ombrellos.arrival = ''
        this.ombrellos.note = ''
        this.ombrellos.departure = ''
        this.ombrellos.guestsinday = []
        this.ombrellos.free = true
        this.$http
          .post(host + '/ombrelloni/close', { ombrellos: this.ombrellos },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // console.log(data)
            this.$modal.hide('hello-world')
            this.getOmbrelli()
          }, (error) => {
            console.log(error)
          })
      },
      addombrell: function () {
        // console.log(this.addombrello, this.hotelid)
        this.$http
          // .get('http://srv5.ghosted.it:8000/authorized',
        // var ombrellos = this.ombrellos
          .post(host + '/ombrelloni/add', { ombrid: this.addombrello.ombrid, hotelid: this.hotelid, location: this.location },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            // console.log(data)
            this.getOmbrelli()
          }, (error) => {
            console.log(error)
          })
      },
      editguest: function (index) {
        // console.log(index.ombrid, index.edit)
        index.edit = true
        // Vue.set(this.ombrelli[index], 'edit', true)
      },
      saveEdit: function (index, guest) {
        // save your changes
        // this.toggleEdit(index, guest)
        // console.log(index, guest)
        Vue.set(this.ombrelli[index], 'guest', guest)
      },
      // presetGrid () {
      //   var grid = this.hotel.cols * this.hotel.rows
      //   if (this.ombrelli.length === grid) {
      //     console.log('preset grid done')
      //   } else {
      //     console.log('preset grid not yet done')
      //     if (this.numbers.first < 10) {
      //       this.pregrid = {
      //         first: {
      //           letter: this.letters.first,
      //           number: '0' + this.numbers.first
      //         },
      //         left: {
      //           letter: this.letters.first,
      //           number: '0' + this.numbers.first
      //         },
      //         up: {
      //           letter: this.letters.first,
      //           number: '0' + this.numbers.first
      //         }
      //       }
      //     } else {
      //       this.pregrid = {
      //         first: {
      //           letter: this.letters.first,
      //           number: this.numbers.first
      //         },
      //         left: {
      //           letter: this.letters.first,
      //           number: this.numbers.first
      //         },
      //         up: {
      //           letter: this.letters.first,
      //           number: this.numbers.first
      //         }
      //       }
      //     }
      //   }
      // },
      resetGrid () {
        this.ombrelli = []
        this.grid.firststep = true
        this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase())
        this.letters.row = 1
        this.numbers.act = this.numbers.first
        this.grid.active = 2
        if (this.letters.first.length === 0 || this.grid.direction === 'empty') {
          this.setemptyGrid()
        } else {
          this.setGrid()
        }
      },
      setemptyGrid () {
        var grid = this.hotel.cols * this.hotel.rows
        // console.log('ombrelli length', (this.ombrelli.length + 1), 'numbers act: ', this.numbers.act)
        if (this.ombrelli.length === grid) {
          // console.log('done')
        } else {
          if (grid > 99 && this.numbers.act <= 9) {
            // console.log('case: 1')
            this.ombrelli.push({ombrid: '00' + (parseInt(this.numbers.act)), free: true})
            this.numbers.act++
          } else if (grid > 99 && this.numbers.act <= 99) {
            // console.log('case: 2')
            this.ombrelli.push({ombrid: '0' + (parseInt(this.numbers.act)), free: true})
            this.numbers.act++
          } else {
            // console.log('case: 3')
            this.ombrelli.push({ombrid: (parseInt(this.numbers.act)), free: true})
            this.numbers.act++
          }
          this.setemptyGrid()
        }
      },
      setGrid () {
        var grid = this.hotel.cols * this.hotel.rows
        // console.log(this.letters.first)
        if (this.letters.act === this.alphabet.length) {
          this.letters.act = 0
        }
        var act = this.alphabet[this.letters.act].toUpperCase()
        // console.log('act: ', act, this.numbers.act)
        if (this.ombrelli.length === grid) {
          // console.log('done')
        } else {
          // console.log('not done')
          if (this.numbers.act < 10) {
            this.ombrelli.push({ombrid: act + '0' + this.numbers.act, free: true})
            console.log('nr: ', act + '0' + this.numbers.act)
            if (this.grid.direction === 'left') {
              this.numbers.act++
            } else {
              this.letters.act++
            }
            if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
              if (this.grid.direction === 'left') {
                this.numbers.act = this.numbers.first
                this.letters.row++
                this.letters.act++
              } else {
                this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase())
                this.numbers.act++
                this.letters.row++
              }
              // console.log('end of row', this.letters.row - 1, this.numbers.act)
            } else {}
            this.setGrid()
          } else {
            this.ombrelli.push({ombrid: act + this.numbers.act, free: true})
            // console.log('nr: ', act + this.numbers.act)
            if (this.grid.direction === 'left') {
              this.numbers.act++
            } else {
              this.letters.act++
            }
            if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
              if (this.grid.direction === 'left') {
                this.numbers.act = this.numbers.first
                this.letters.row++
                this.letters.act++
              } else {
                this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase())
                this.numbers.act++
                this.letters.row++
              }
              // console.log('end of row', this.letters.row - 1, this.numbers.act)
            } else {}
            this.setGrid()
          }
        }
      },
      saveGrid: function () {
        // console.log(this.ombrelli)
        this.$http
          .post(host + '/api/savegrid', { hotel: this.hotel, ombrelli: this.ombrelli },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // console.log(data)
            this.getOmbrelli()
            this.nogrid = false
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'grid saved',
              type: 'success',
              duration: 500
            })
          })
      },
      changeDate () {
        // console.log(moment(this.today).format('YYYY-MM-DD'))
        this.today = moment(this.today).format('YYYY-MM-DD')
        this.range.startDate = moment(this.today)
        this.getOmbrelli()
        this.rangeview = false
      },
      changeRange () {
        this.loading = true
        // console.log(moment(this.rangepicker).format('YYYY-MM-DD'))
        var start = moment(this.rangepicker[0], 'YYYY-MM-DD')
        var end = moment(this.rangepicker[1], 'YYYY-MM-DD')
        var range = moment.range(start, end)
        var dates = Array.from(range.by('days')).map(m => m.format('YYYY-MM-DD'))
        // console.log('range picker dates: ', dates)
        this.rangestyle = 'grid-template-rows: repeat(' + dates.length + ', 1fr);'
        this.rangeviewdata = dates
        // var set = this.ombrelli.length * dates.length
        var count = 1
        console.log('count: ', count)
        this.ombrelli.forEach((ombrello, indexo) => {
          Vue.set(this.ombrelli[indexo], 'dates', [])
          dates.forEach((date, indexd) => {
            this.ombrelli[indexo].dates.push({date: moment(date).format('DD'), fulldate: moment(date).format('YYYY-MM-DD'), day: moment(date).format('dd'), ombrid: ombrello.ombrid, guests: [], free: true})
            if (count === (this.ombrelli.length * dates.length)) {
              console.log('count done')
              this.loading = false
              this.rangeview = true
              return true
            } else {
              count++
              console.log('count not done')
              ombrello.guests.forEach((guest, index) => {
                if (moment(date).isBetween(guest.arrival, guest.departure, null, this.hotel.singledaybooking ? '[]' : '[)')) {
                  this.ombrelli[indexo].dates[indexd].guests.push(guest)
                  this.ombrelli[indexo].dates[indexd].free = false
                  this.ombrelli[indexo].dates[indexd].guestnr = index
                } else {
                }
              })
            }
          })
        })
      },
      getOmbrelli () {
        this.$http
          .post(host + '/ombrelloni/all', { hotelid: this.$route.params.hotel },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // console.log('hotel: ', data.body.ombrells)
            this.hotelid = data.body.hotels._id
            this.hotel = data.body.hotels
            moment.locale(data.body.hotels.lang)
            if (data.body.hotels.chairs === undefined) {
              this.hotel.chairs = 1
            }
            if (data.body.hotels.beds === undefined) {
              this.hotel.beds = 1
            }
            this.style = 'grid-template-columns: repeat(' + data.body.hotels.cols + ', 1fr); grid-template-rows: repeat(' + data.body.hotels.rows + ', auto);'
            this.ombrelli = []
            data.body.ombrells.forEach((ombrello, indexo) => {
              this.ombrelli.push(ombrello)
              ombrello.guests.forEach((guest, index) => {
                if (moment(this.today).isBetween(guest.arrival, guest.departure, null, this.hotel.singledaybooking ? '[]' : '[)')) {
                  // console.log('guest: ', guest, 'ombrello: ', this.ombrelli[indexo])
                  this.ombrelli[indexo].guest = guest.name
                  this.ombrelli[indexo].room = guest.room
                  this.ombrelli[indexo].arrival = guest.arrival
                  this.ombrelli[indexo].departure = guest.departure
                  this.ombrelli[indexo].free = false
                  this.ombrelli[indexo].note = guest.note
                  this.ombrelli[indexo].guestnr = index
                  if (guest.passid) {
                    this.ombrelli[indexo].passid = guest.passid
                  }
                  if (!guest.items) {
                    // console.log('no items')
                    this.ombrelli[indexo].items = this.hotel.items
                  } else {
                    this.ombrelli[indexo].items = guest.items
                  }
                  this.ombrelli[indexo].guestsinday.push(guest)
                } else {
                }
              })
            })
            this.getOverview()
            // var grid = this.hotel.cols * this.hotel.rows
            if (!this.hotel.firststep && data.body.ombrells <= 0) {
              // this.nogrid = true
              // this.setGrid()
            }
            this.loading = false
            if (this.rangeview) {
              this.changeRange()
            }
            // this.$notify({
            //   group: 'foo',
            //   title: 'Hoteldata loaded',
            //   text: 'You are good to go',
            //   type: 'success',
            //   duration: 500
            // })
          }, (error) => {
            console.log(error)
            this.$router.replace('/')
          })
      },
      getOverview () {
        this.overview.arrivals = []
        this.overview.departures = []
        this.overview.stays = []
        this.ombrelli.forEach((ombrello, indexo) => {
          ombrello.guests.forEach((guest, index) => {
            if (moment(this.today).isSame(guest.arrival)) {
              this.overview.arrivals.push({guest: guest, ombrello: ombrello})
            } else if (moment(this.today).isSame(guest.departure)) {
              this.overview.departures.push({guest: guest, ombrello: ombrello, guestindex: index})
            } else if (moment(this.today).isBetween(guest.arrival, guest.departure, null, '()')) {
              this.overview.stays.push({guest: guest, ombrello: ombrello})
            }
          })
        })
      },
      addchair (index, nr, chair, hotel) {
        // console.log(this.ombrelli)
        // console.log(index, chair, hotel)
        var newchairs = nr + 1
        this.$http
          .post(host + '/api/addchair/' + chair, {chairid: chair, hotelid: hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            // this.loading = false
            Vue.set(this.ombrelli[index], 'chairs', newchairs)
            this.$notify({
              group: 'foo',
              title: 'Chair added',
              type: 'success',
              duration: 500
            })
          }, (error) => {
            console.log(error)
          })
      },
      removechair (index, nr, chair, hotel) {
        // console.log(this.ombrelli)
        // console.log(index, chair, hotel)
        var newchairs = nr - 1
        this.$http
          .post(host + '/api/removechair/' + chair, {chairid: chair, hotelid: hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            // this.loading = false
            Vue.set(this.ombrelli[index], 'chairs', newchairs)
          }, (error) => {
            console.log(error)
          })
      },
      addbed (index, nr, chair, hotel) {
        // console.log(this.ombrelli)
        // console.log(index, chair, hotel)
        var newchairs = nr + 1
        this.$http
          .post(host + '/api/addbed/' + chair, {chairid: chair, hotelid: hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            // this.loading = false
            Vue.set(this.ombrelli[index], 'beds', newchairs)
          }, (error) => {
            console.log(error)
          })
      },
      removebed (index, nr, chair, hotel) {
        // console.log(this.ombrelli)
        // console.log(index, chair, hotel)
        var newchairs = nr - 1
        this.$http
          .post(host + '/api/removebed/' + chair, {chairid: chair, hotelid: hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            // this.loading = false
            Vue.set(this.ombrelli[index], 'beds', newchairs)
          }, (error) => {
            console.log(error)
          })
      },
      changeguest (index, chair, guest) {
        // console.log(this.ombrelli)
        // console.log(index, chair, guest)
        // var newchairs = nr - 1
        // this.$http
        //   .post(host + '/api/removebed/' + chair, {chairid: chair, hotelid: hotel},
        //   {
        //     headers: {
        //       'Authorization': 'Bearer ' + localStorage.jwt
        //     }
        //   },
        //   ).then((data) => {
        //     console.log(data)
        //     // this.loading = false
        //     Vue.set(this.ombrelli[index], 'beds', newchairs)
        //   }, (error) => {
        //     console.log(error)
        //   })
      }
    },
    beforeMount () {
      this.getOmbrelli()
      this.letters.act = this.alphabet.indexOf(this.letters.first)
    },
    mounted: function () {
      // this.getOverview()
      // moment.locale(this.hotel.lang)
      // console.log('hotel: ', this.hotel)
    },
    computed: {
      cashierbasket () {
        var tocash = 0
        var extra = 0
        console.log(this.disabledDatesBasket)
        // console.log(this.ombrellos.guests[0])
        var start = moment(this.checkoutbasket.guests[0].arrival)
        // var end = moment(this.checkoutbasket.guests[0].departure).subtract(1, 'days')
        var end = this.hotel.singledaybooking ? moment(this.checkoutbasket.guests[0].departure) : moment(this.checkoutbasket.guests[0].departure).subtract(1, 'days')
        // if (moment(date).isBetween(guest.arrival, guest.departure, null, this.hotel.singledaybooking ? '[]' : '[)')) {
        var range = moment.range(start, end)
        var dates = Array.from(range.by('days')).map(m => m.format('YYYY-MM-DD'))
        console.log('dates: ', dates)
        dates.forEach((date, index) => {
          // console.log(date)
          this.checkoutbasket.seasons.forEach((season, index) => {
            // console.log(season)
            if (moment(date).isBetween(season.start, season.end, null, '[]')) {
              console.log(date + ' is in ' + season.name, season.amount, this.checkoutbasket.guests)
              this.checkoutbasket.guests[0].items.forEach((item, index) => {
                // console.log(item)
                extra = parseInt(extra) + (parseInt(item.num) * parseInt(season.items[index].price))
              })
              tocash = parseInt(tocash) + parseInt(season.amount)
            }
          })
        })
        return {
          tocash: tocash.toFixed(2),
          extra: extra.toFixed(2),
          total: (parseInt(tocash) + parseInt(extra)).toFixed(2)
        }
      },
      hotelgrid: function () {
      // `this` points to the vm instance
        this.numbers.last = this.hotel.cols * this.hotel.rows
        return this.hotel.cols * this.hotel.rows
      },
      state: function () {
        // console.log('today: ', this.today)
      },
      filteredArrivals () {
        // console.log('filteredArrivals')
        return this.overview.arrivals.filter(post => {
          var arrivals = post.guest.name.toLowerCase().includes(this.query.toLowerCase())
          var arrivalsroom = post.guest.room.toLowerCase().includes(this.query.toLowerCase())
          // console.log(arrivals)
          if (arrivals) {
            return arrivals
          } else {
            return arrivalsroom
          }
        })
      },
      filteredDepartures () {
        return this.overview.departures.filter(post => {
          var departures = post.guest.name.toLowerCase().includes(this.query.toLowerCase())
          var departuresroom = post.guest.room.toLowerCase().includes(this.query.toLowerCase())
          if (departures) {
            return departures
          } else {
            return departuresroom
          }
        })
      },
      filteredStays () {
        return this.overview.stays.filter(post => {
          var stays = post.guest.name.toLowerCase().includes(this.query.toLowerCase())
          var staysroom = post.guest.room.toLowerCase().includes(this.query.toLowerCase())
          if (stays) {
            return stays
          } else {
            return staysroom
          }
        })
      },
      pregrid () {
        var next = this.alphabet.indexOf(this.letters.first.toLowerCase()) + 1
        if (this.letters.first.length > 0) {
          if (this.numbers.first < 10) {
            return { first: { letter: this.letters.first.toUpperCase(), number: '0' + this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: '0' + this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) } }
          } else {
            return { first: { letter: this.letters.first.toUpperCase(), number: this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: (parseInt(this.numbers.first) + 1) } }
          }
        } else {
          console.log('no letter', this.hotel.cols)
          if (this.numbers.first < 10) {
            return { first: { letter: this.letters.first.toUpperCase(), number: '0' + this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: '0' + this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) } }
          } else {
            return { first: { letter: this.letters.first.toUpperCase(), number: this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: (this.hotel.cols + 1) }, upleft: { letter: this.alphabet[next].toUpperCase(), number: (parseInt(this.hotel.cols) + 1) } }
          }
        }
        // if (this.numbers.first < 10) {
        //   return { first: { letter: this.letters.first.toUpperCase(), number: '0' + this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: '0' + this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) } }
        // } else {
        //   return { first: { letter: this.letters.first.toUpperCase(), number: this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: (parseInt(this.numbers.first) + 1) } }
        // }
      }
    }
  }
</script>

<style>
  a {
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// Ombrelli.vue?88e024e2